import { programRequestsApi } from '../api/programRequestsApi';
import { toNewProgramRequest } from './newProgramModel';

export const createNewProgramFlow = async ({
    form,
    files,
    onError,
    api = programRequestsApi,
}) => {
    const result = await api.createNewProgram(toNewProgramRequest(form), onError);
    if (!result) return false;

    if (files?.length) {
        await api.uploadFiles(files, result.requestId);
    }

    return true;
};
